import { useState } from 'react';
import { TODAY, DOY, YR } from '../lib/dateState.js';
import { REWARDS_CATALOG, QUARTERLY_GOALS, DAILY_GOALS_POOL, MONTHLY_GOALS } from '../lib/constants.js';
import { computeMetrics, getSeasonForMonth, pickDailyGoals, goalProgress } from '../lib/helpers.js';
import { Btn } from '../components/Basic.jsx';
import { BNav, mainNavItems } from '../components/Navigation.jsx';
import { GoalProgressRow } from '../components/SettingsShared.jsx';
import { t as tr } from '../lib/i18n.js';
export function GoalsView({t,st,dispatch,go}){
  const metrics=computeMetrics(st);
  const season=getSeasonForMonth(TODAY.getMonth());
  const quarterlyGoals=QUARTERLY_GOALS[season.q]||[];
  // Stessi 3 obiettivi per tutta la giornata (seed = anno+giorno dell'anno),
  // ma diversi da un giorno all'altro — vedi pickDailyGoals in helpers.js.
  const dailyGoals=pickDailyGoals(DAILY_GOALS_POOL,YR*1000+DOY,3);
  const allDailyDone=dailyGoals.length>0&&dailyGoals.every(g=>goalProgress(g,metrics).done);
  const [justClaimed,setJustClaimed]=useState(null);
  const claimed=st.rewards.claimed;
  const handleClaim=(goal)=>{
    dispatch({type:"CLAIM_GOAL",goalId:goal.id,rewardId:goal.reward,filterReward:goal.filterReward});
    setJustClaimed(REWARDS_CATALOG.find(r=>r.id===goal.reward));
  };
  const showEvent=season.event&&TODAY.getMonth()===season.event.month;
  return(
    <div className="screen fade" style={{background:t.bg}}>
      <div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${t.bord}`,flexShrink:0,background:t.card}}>
        <div onClick={()=>go("profile_me")} style={{width:32,height:32,borderRadius:"50%",background:t.bord,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:14,color:t.tx}}>←</div>
        <span style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("goals_header_title")}</span>
        <div onClick={()=>go("rewards")} style={{marginLeft:"auto",fontSize:11,color:"#FF2D6B",fontWeight:700,fontFamily:"Inter,sans-serif",cursor:"pointer"}}>{tr("goals_rewards_link")}</div>
      </div>
      <div style={{padding:"14px 16px 40px",flex:1,overflowY:"auto"}}>
        {/* Season banner */}
        <div style={{background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",borderRadius:16,padding:"16px 17px",marginBottom:18,color:"#fff"}}>
          <div style={{fontSize:13,fontWeight:800,marginBottom:3}}>{tr("goals_season_banner",{icon:season.icon,name:season.name})}</div>
          <div style={{fontSize:11,opacity:.9,lineHeight:1.5}}>
            {showEvent?tr("goals_event_banner",{icon:season.event.icon,event:season.event.name}):tr("goals_season_default_banner")}
          </div>
        </div>
        <div style={{display:"flex",alignItems:"baseline",justifyContent:"space-between",marginBottom:2}}>
          <div style={{fontSize:10,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1px",textTransform:"uppercase"}}>{tr("goals_section_today")}</div>
          {allDailyDone&&<div style={{fontSize:10.5,fontWeight:700,color:"#2D6A4F",fontFamily:"Inter,sans-serif"}}>{tr("goals_daily_all_done")}</div>}
        </div>
        <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",opacity:.75,marginBottom:10}}>{tr("goals_daily_subtitle")}</div>
        {dailyGoals.map(g=><GoalProgressRow key={g.id} goal={g} metrics={metrics} claimed={claimed} onClaim={handleClaim} t={t}/>)}
        <div style={{fontSize:10,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1px",textTransform:"uppercase",marginBottom:10,marginTop:18}}>{tr("goals_section_month")}</div>
        {MONTHLY_GOALS.map(g=><GoalProgressRow key={g.id} goal={g} metrics={metrics} claimed={claimed} onClaim={handleClaim} t={t}/>)}
        <div style={{fontSize:10,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1px",textTransform:"uppercase",marginBottom:10,marginTop:18}}>{tr("goals_section_season")}</div>
        {quarterlyGoals.map(g=><GoalProgressRow key={g.id} goal={g} metrics={metrics} claimed={claimed} onClaim={handleClaim} t={t}/>)}
        <div style={{marginTop:16,fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",textAlign:"center",lineHeight:1.6}}>
          {tr("goals_footer_note")}
        </div>
      </div>
      {justClaimed&&(
        <div className="overlay" onClick={()=>setJustClaimed(null)}>
          <div className="sheet" style={{textAlign:"center",padding:"36px 24px"}}>
            <div style={{fontSize:52,marginBottom:14}}>{justClaimed.emoji}</div>
            <div style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif",marginBottom:6}}>{tr("goals_claimed_title",{name:justClaimed.name})}</div>
            <div style={{fontSize:12,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:4}}>
              {justClaimed.type==="sticker"&&tr("goals_claim_sticker")}
              {justClaimed.type==="badge"&&tr("goals_claim_badge")}
              {justClaimed.type==="divider"&&tr("goals_claim_divider")}
              {justClaimed.type==="filter"&&tr("goals_claim_filter")}
            </div>
            <div style={{fontSize:10.5,color:t.soft,fontFamily:"Inter,sans-serif",opacity:.75,marginBottom:20}}>{tr(`reward_usage_${justClaimed.type}`)}</div>
            <Btn fn={()=>setJustClaimed(null)} style={{background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:"#fff",padding:"12px 28px",borderRadius:40,fontSize:13,fontWeight:700,fontFamily:"Inter,sans-serif",display:"inline-block"}}>{tr("goals_claim_cta")}</Btn>
          </div>
        </div>
      )}
      <BNav t={t} items={mainNavItems("profile",t,go,st)}/>
    </div>
  );
}
export function RewardsView({t,st,dispatch,go}){
  const [cat,setCat]=useState("Tutti");
  const cats=["Tutti","sticker","badge","divider","filter"];
  const catLabels={Tutti:tr("rewards_cat_all"),"sticker":tr("rewards_cat_sticker"),"badge":tr("rewards_cat_badge"),"divider":tr("rewards_cat_divider"),"filter":tr("rewards_cat_filter")};
  const owned=REWARDS_CATALOG.filter(r=>st.rewards.unlocked.includes(r.id));
  const locked=REWARDS_CATALOG.filter(r=>!st.rewards.unlocked.includes(r.id));
  const filtered=(cat==="Tutti"?owned:owned.filter(r=>r.type===cat));
  const equipped=st.rewards.equippedDecor||[null,null];
  return(
    <div className="screen fade" style={{background:t.bg}}>
      <div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${t.bord}`,flexShrink:0,background:t.card}}>
        <div onClick={()=>go("goals")} style={{width:32,height:32,borderRadius:"50%",background:t.bord,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:14,color:t.tx}}>←</div>
        <span style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("rewards_header_title")}</span>
      </div>
      <div style={{padding:"12px 16px 40px",flex:1,overflowY:"auto"}}>
        <div style={{fontSize:11,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:14}}>{tr("rewards_unlocked_count",{n:owned.length,total:REWARDS_CATALOG.length})}</div>
        <div style={{display:"flex",gap:6,overflowX:"auto",scrollbarWidth:"none",marginBottom:16,paddingBottom:2}}>
          {cats.map(c=>(
            <div key={c} onClick={()=>setCat(c)} style={{flexShrink:0,padding:"6px 13px",borderRadius:20,cursor:"pointer",background:cat===c?"linear-gradient(135deg,#FF2D6B,#7B2FFF)":t.card,border:cat===c?"none":`1px solid ${t.bord}`,fontSize:11,fontFamily:"Inter,sans-serif",fontWeight:700,color:cat===c?"#fff":t.soft}}>{catLabels[c]}</div>
          ))}
        </div>
        {cat==="divider"&&owned.some(r=>r.type==="divider")&&(
          <div style={{background:t.card,borderRadius:14,padding:14,border:`1px solid ${t.bord}`,marginBottom:16}}>
            <div style={{fontSize:11.5,fontWeight:700,color:t.tx,fontFamily:"Inter,sans-serif",marginBottom:10}}>{tr("rewards_equip_title")}</div>
            <div style={{display:"flex",gap:9}}>
              {[0,1].map(slot=>(
                <div key={slot} style={{flex:1}}>
                  <div style={{fontSize:9,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:5}}>{tr("rewards_slot_label",{n:slot+1})}</div>
                  <select value={equipped[slot]||""} onChange={e=>dispatch({type:"EQUIP_DECOR",slot,itemId:e.target.value||null})} style={{width:"100%",padding:"8px 10px",borderRadius:10,border:`1px solid ${t.bord}`,fontSize:12,fontFamily:"Inter,sans-serif"}}>
                    <option value="">{tr("rewards_none_option")}</option>
                    {owned.filter(r=>r.type==="divider").map(r=>(
                      <option key={r.id} value={r.id}>{r.emoji} {r.name}</option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
          </div>
        )}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          {filtered.map(r=>(
            <div key={r.id} style={{background:t.card,borderRadius:14,padding:14,border:`1px solid ${t.bord}`,textAlign:"center"}}>
              <div style={{fontSize:32,marginBottom:8}}>{r.emoji}</div>
              <div style={{fontSize:11.5,fontWeight:700,color:t.tx,fontFamily:"Inter,sans-serif"}}>{r.name}</div>
              <div style={{fontSize:9,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:2,textTransform:"capitalize"}}>{catLabels[r.type]}</div>
              <div style={{fontSize:8.5,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:1,opacity:.75}}>{tr(`reward_usage_${r.type}`)}</div>
            </div>
          ))}
          {filtered.length===0&&<div style={{gridColumn:"1 / -1",textAlign:"center",padding:"20px",color:t.soft,fontFamily:"Inter,sans-serif",fontSize:12}}>{tr("rewards_empty_state")}</div>}
        </div>
        {locked.length>0&&(
          <>
            <div style={{fontSize:10,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1px",textTransform:"uppercase",margin:"22px 0 10px"}}>{tr("rewards_still_locked_label")}</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {locked.map(r=>(
                <div key={r.id} style={{background:t.card,borderRadius:14,padding:14,textAlign:"center",opacity:.55}}>
                  <div style={{fontSize:32,marginBottom:8,filter:"grayscale(1)"}}>🔒</div>
                  <div style={{fontSize:11.5,fontWeight:700,color:t.soft,fontFamily:"Inter,sans-serif"}}>{r.name}</div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <BNav t={t} items={mainNavItems("profile",t,go,st)}/>
    </div>
  );
}
